export function cleanObject(object) {
    for (const key of Object.keys(object)) {
        delete object[key]
    }
    return object
}
